import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';

export default function FormSuccessfullySent() {
  const phoneNumber = '+1 (954) 715-4114';
  return (
    <SentWrapper>
      <SentIcon className="Icon Icon-confirmation Icon-4x u-textSuccess"></SentIcon>
      <SentHeading>
        <Trans id="contact.form.sent.heading" />
      </SentHeading>
      <SentDescription>
        <Trans id="contact.form.sent.description" />
      </SentDescription>
      <SentButton href={`tel:${phoneNumber}`}>
        <Trans id="contact.form.sent.callUs" />
      </SentButton>
    </SentWrapper>
  );
}

const SentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const SentIcon = styled.i`
  margin-bottom: 0.5em;
  &:before {
    color: green;
  }
`;

const SentHeading = styled.div`
  font-size: 21px;
  line-height: 27px;
  margin-bottom: 0.333333em;
  font-weight: 600;
  color: #17233c;
`;

const SentDescription = styled.div`
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 1em;
  color: #4b5765;
`;

const SentButton = styled.a`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: solid 1px #102a5e;
  border-radius: 6px;
  background-color: #102a5e;
  padding: 1em 1.4em;
  color: #fff;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;
`;
